// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:500,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable-next-line import-notation */
html {
  font-size: 10px;
}

a {
  color: #0e52b7;
  outline: none;
  text-decoration: none;
}

* {
  font-family: montserrat, sans-serif;
  -webkit-tap-highlight-color: transparent;
  font-size: 1.6rem;
  line-height: 1.5;
}
* > strong, * span {
  font-size: inherit;
  line-height: inherit;
}

span, p, a, input, textarea, ul, ol, li, div {
  font-weight: 500;
}

ul > li:not(:last-child), ol > li:not(:last-child) {
  padding-bottom: 1.2rem;
}

h1, h2, h3, h4, h5 {
  line-height: 1.25;
}

h1 {
  font-size: 4.8rem;
}
@media screen and (width >= 720px) and (width <= 1023px) {
  h1 {
    font-size: 4rem;
  }
}
@media screen and (width <= 719px) {
  h1 {
    font-size: 3.2rem;
  }
}

h2 {
  font-size: 3.6rem;
}
@media screen and (width >= 720px) and (width <= 1023px) {
  h2 {
    font-size: 3.2rem;
  }
}
@media screen and (width <= 719px) {
  h2 {
    font-size: 2.6rem;
  }
}

h3 {
  font-size: 2.8rem;
}
@media screen and (width >= 720px) and (width <= 1023px) {
  h3 {
    font-size: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  h3 {
    font-size: 2.2rem;
  }
}

h4 {
  font-size: 2.4rem;
}
@media screen and (width >= 720px) and (width <= 1023px) {
  h4 {
    font-size: 2.2rem;
  }
}
@media screen and (width <= 719px) {
  h4 {
    font-size: 2rem;
  }
}

h5 {
  font-size: 1.8rem;
}

.small {
  font-size: 1.2rem;
  line-height: 1.5;
}

.small-2 {
  font-size: 1rem;
  line-height: 1.5;
}
.small-2 > * {
  font-size: inherit;
  line-height: inherit;
}
@media screen and (width <= 719px) {
  .small-2 {
    font-size: 1.2rem;
  }
}

.medium {
  font-weight: 500;
}

.semi-bold {
  font-weight: 600;
}

.bold {
  font-weight: 700;
}

.blue-text {
  color: #0e52b7;
}

.black-text {
  color: #000;
}

.white-text {
  color: #fff;
}

.red-text {
  color: #be1e2d;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}
.link:hover {
  opacity: 0.75;
}

.uppercase-text {
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/typography.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAGA,gDAAA;AAGA;EACE,eAAA;AAHF;;AAMA;EACE,cCFiB;EDGjB,aAAA;EACA,qBAAA;AAHF;;AAMA;EACE,mCAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AAHF;AAKE;EACE,kBAAA;EACA,oBAAA;AAHJ;;AAOA;EACE,gBAAA;AAJF;;AAQE;EACE,sBAAA;AALJ;;AASA;EACE,iBAAA;AANF;;AASA;EACE,iBAAA;AANF;AAQE;EAHF;IAII,eAAA;EALF;AACF;AAOE;EAPF;IAQI,iBAAA;EAJF;AACF;;AAOA;EACE,iBAAA;AAJF;AAME;EAHF;IAII,iBAAA;EAHF;AACF;AAKE;EAPF;IAQI,iBAAA;EAFF;AACF;;AAKA;EACE,iBAAA;AAFF;AAIE;EAHF;IAII,iBAAA;EADF;AACF;AAGE;EAPF;IAQI,iBAAA;EAAF;AACF;;AAGA;EACE,iBAAA;AAAF;AAEE;EAHF;IAII,iBAAA;EACF;AACF;AACE;EAPF;IAQI,eAAA;EAEF;AACF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,iBAAA;EACA,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;AAEF;AAAE;EACE,kBAAA;EACA,oBAAA;AAEJ;AACE;EATF;IAUI,iBAAA;EAEF;AACF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,cCrHiB;ADuHnB;;AACA;EACE,WCjHW;ADmHb;;AACA;EACE,WCzGW;AD2Gb;;AACA;EACE,cC9HS;ADgIX;;AACA;EACE,0BAAA;EACA,eAAA;AAEF;AAAE;EACE,aAAA;AAEJ;;AAEA;EACE,yBAAA;AACF","sourcesContent":["@use '@Styles/variables';\n\n// TODO when we switch to create-react-app we need to standardize this\n/* stylelint-disable-next-line import-notation */\n@import url('https://fonts.googleapis.com/css?family=Montserrat:500,700&display=swap');\n\nhtml {\n  font-size: 10px;\n}\n\na {\n  color: variables.$primaryBlueColor;\n  outline: none;\n  text-decoration: none;\n}\n\n* {\n  font-family: montserrat, sans-serif;\n  -webkit-tap-highlight-color: transparent;\n  font-size: 1.6rem;\n  line-height: 1.5;\n\n  &>strong, span{\n    font-size: inherit;\n    line-height: inherit;\n  }\n}\n\nspan, p, a, input, textarea, ul, ol, li, div {\n  font-weight: 500;\n}\n\nul, ol{\n  &>li:not(:last-child){\n    padding-bottom: 1.2rem;\n  }\n}\n\nh1, h2, h3, h4, h5 {\n  line-height: 1.25;\n}\n\nh1 {\n  font-size: 4.8rem;\n\n  @media screen and (width >= 720px) and (width <= 1023px) {\n    font-size: 4rem;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 3.2rem;\n  }\n}\n\nh2 {\n  font-size: 3.6rem;\n\n  @media screen and (width >= 720px) and (width <= 1023px) {\n    font-size: 3.2rem;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 2.6rem;\n  }\n}\n\nh3 {\n  font-size: 2.8rem;\n\n  @media screen and (width >= 720px) and (width <= 1023px) {\n    font-size: 2.4rem;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 2.2rem;\n  }\n}\n\nh4 {\n  font-size: 2.4rem;\n\n  @media screen and (width >= 720px) and (width <= 1023px) {\n    font-size: 2.2rem;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 2rem;\n  }\n}\n\nh5 {\n  font-size: 1.8rem;\n}\n\n.small {\n  font-size: 1.2rem;\n  line-height: 1.5;\n}\n\n.small-2 {\n  font-size: 1rem;\n  line-height: 1.5;\n\n  &>*{\n    font-size: inherit;\n    line-height: inherit;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 1.2rem;\n  }\n}\n\n.medium {\n  font-weight: 500;\n}\n\n.semi-bold {\n  font-weight: 600;\n}\n\n.bold {\n  font-weight: 700;\n}\n\n.blue-text {\n  color: variables.$primaryBlueColor;\n}\n\n.black-text {\n  color: variables.$blackColor;\n}\n\n.white-text {\n  color: variables.$whiteColor;\n}\n\n.red-text {\n  color: variables.$redColor;\n}\n\n.link{\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover{\n    opacity: 0.75;\n  }\n}\n\n.uppercase-text {\n  text-transform: uppercase;\n\n}\n","@use 'sass:map';\n\n$themeMap: null;\n$adminPrimaryBlueColor: #4254f9;\n$adminPrimaryTextColor: #595e8d;\n$adminComponentsShadow: 0 5px 20px rgba(22, 33, 133, 0.05);\n$adminListItemsPadding: 22px;\n$adminTextColor: #595e8d;\n$adminTitleSecondaryColor: #4a6507;\n$primaryBlueColor: #0e52b7;\n$secondaryBlueColor: #0f426b;\n$hoverBlueColor: #2676ed;\n$redColor: #be1e2d;\n$redLightColor: #dd5050;\n$orangeColor: #e27538;\n$yellowColor: #ffd200;\n$greenColor: #95c900;\n$blackColor: #000;\n$grayColor1: #333;\n$grayColor2: #4f4f4f;\n$grayColor3: #828282;\n$grayColor4: #bdbdbd;\n$grayColor5: #e0e0e0;\n$grayColor6: #f2f2f2;\n$grayColor7: #bebebe;\n$grayColor8: #dadada;\n$greyColorForBorder: #c4c4c4;\n$greyColorForTableHeader: #585858;\n$backgroundGrey: #f9f9f9;\n$whiteColor: #fff;\n$offWhiteColor: #fafafa;\n$creamColor: #f9f9f9;\n$sidebarWidth: 31rem;\n$statusIncompleteColor: #ffd200;\n$statusSubmittedColor: #ffd200;\n$statusPendingColor: #55bfff;\n$statusAcceptedColor: #95c900;\n$statusPartiallyAcceptedColor: darkblue;\n$statusRejectedColor: #be1e2d;\n$statusSupersededColor: #ad00ff;\n$overclaimStatusColor: #ffd200;\n$disputeStatusColor: #be1e2d;\n$closedStatusColor: #95c900;\n$mergedStatusColor: #0e52b7;\n$canceledStatusColor: #4f4f4f;\n$filterPrimaryBlue: invert(24%) sepia(76%) saturate(1733%) hue-rotate(201deg) brightness(92%) contrast(104%);\n$filterSecondaryBlue: invert(17%) sepia(25%) saturate(5155%) hue-rotate(189deg) brightness(91%) contrast(88%);\n$filterHoverBlue: invert(34%) sepia(83%) saturate(3609%) hue-rotate(208deg) brightness(103%) contrast(86%);\n$filterRed: invert(17%) sepia(64%) saturate(4146%) hue-rotate(342deg) brightness(90%) contrast(94%);\n$filterRedLight: invert(32%) sepia(63%) saturate(972%) hue-rotate(320deg) brightness(113%) contrast(88%);\n$filterOrange: invert(53%) sepia(57%) saturate(622%) hue-rotate(336deg) brightness(92%) contrast(93%);\n$filterYellow: invert(85%) sepia(27%) saturate(4207%) hue-rotate(359deg) brightness(105%) contrast(104%);\n$filterGreen: invert(75%) sepia(49%) saturate(3003%) hue-rotate(30deg) brightness(94%) contrast(111%);\n$filterGray1: invert(19%) sepia(0%) saturate(0%) hue-rotate(57deg) brightness(97%) contrast(94%);\n$filterGray2: invert(27%) sepia(43%) saturate(0%) hue-rotate(198deg) brightness(97%) contrast(91%);\n$filterGray3: invert(52%) sepia(0%) saturate(671%) hue-rotate(147deg) brightness(98%) contrast(80%);\n$filterGray4: invert(90%) sepia(0%) saturate(1315%) hue-rotate(136deg) brightness(89%) contrast(79%);\n$filterGray5: invert(80%) sepia(99%) saturate(0%) hue-rotate(138deg) brightness(92%) contrast(101%);\n$filterGray6: invert(100%) sepia(5%) saturate(192%) hue-rotate(202deg) brightness(115%) contrast(90%);\n$filterWhite: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);\n$filterNoOp: initial;\n$themes: (\n  member-standard: (\n    navigation-primary-background: $grayColor6,\n    navigation-secondary-background: $whiteColor,\n    navigation-tertiary-background: $primaryBlueColor,\n    navigation-inverse-background: $primaryBlueColor,\n    navigation-primary-text: $blackColor,\n    navigation-secondary-text: $primaryBlueColor,\n    navigation-inverse-text: $whiteColor,\n    navigation-primary-filter: $filterPrimaryBlue,\n    navigation-primary-border: 1px solid $grayColor5,\n    navigation-account-badge-display: block,\n  ),\n  songwriter-standard: (\n    navigation-primary-background: $secondaryBlueColor,\n    navigation-secondary-background: $secondaryBlueColor,\n    navigation-tertiary-background: $primaryBlueColor,\n    navigation-inverse-background: $whiteColor,\n    navigation-primary-text: $whiteColor,\n    navigation-secondary-text: $whiteColor,\n    navigation-inverse-text: $primaryBlueColor,\n    navigation-primary-filter: $filterWhite,\n    navigation-primary-border: 1px solid $primaryBlueColor,\n    navigation-account-badge-display: none,\n  ),\n);\n\n@mixin themed() {\n  @each $theme, $map in $themes {\n    .theme--#{$theme} & {\n      $themeMap: () !global;\n\n      @each $key, $submap in $map {\n        $value: map.get(map.get($themes, $theme), '#{$key}');\n        $themeMap: map.merge(\n          $themeMap,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n\n      $themeMap: null !global;\n    }\n  }\n}\n\n@function theme($key) {\n  @return map.get($themeMap, $key);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
